/**
 * Block 1.
 *
 * @see https://developer.wordpress.org/block-editor/how-to-guides/block-tutorial/writing-your-first-block-type/
 */
 import { __ } from '@wordpress/i18n';
 import { registerBlockType } from '@wordpress/blocks';


/**
 * Internal dependencies
 */
import edit from './edit';
import save from './save';
import PtlIcon from './icons';
// //import deprecated from './deprecated';

// // import metadata from './block.json';


let metadata = {
    title: __('Post Timeline Shortcode'),
    icon: PtlIcon,
    category: 'layout',
    keywords: [
        __('Custom Block'),
        __('post-timeline Block'),
        __('post-timeline'),
        __('ptl-block'),
        __('ptl'),
    ],
    supports: {
        html: false,
        className: false,
        customClassName: false,
    },
    attributes: {
      shortcode: {
        string: 'string',
        source: 'text',
      }
    },
	/**
	 * @see ./edit.js
	 */
	edit,
	
	/**
	 * @see ./save.js
	 */
	save,

};

registerBlockType( 'post-timeline/shortcode', metadata );




   